import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { LoginService } from './services/login/login.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  isHousehold = false;
  isMrBin = false;
  isDepot = false;
  isAdmin = false;

  constructor(
    private auth: AngularFireAuth,
    private loginService: LoginService
  ) {
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.loginService.verifyID(user.uid).subscribe((res) => {
          if (res.exists) {
            const data: any = res.data();
            const role = data.role;
            if (role === 'Household') {
              this.disableRoles();
              this.isHousehold = true;
            } else if (role === 'MrBin') {
              this.disableRoles();
              this.isMrBin = true;
            } else if (role === 'Depot') {
              this.disableRoles();
              this.isDepot = true;
            } else if (role === 'Admin') {
              this.disableRoles();
              this.isAdmin = true;
            }
          }
        });
      }
    });
  }

  disableRoles() {
    this.isHousehold = false;
    this.isMrBin = false;
    this.isDepot = false;
    this.isAdmin = false;
  }
}
